
import ArticleListItem from '@/components/ArticleListItem'

export default {
  name: 'ArticleList',
  components: {
    ArticleListItem,
  },
  props: {
    col: {
      default: 3,
      type: Number,
    },
    nameIsH2: {
      default: true,
      type: Boolean,
    },
    showInCarousel: {
      default: false,
      type: Boolean,
    },
    articles_list: Array,
  },
  data() {
    return {}
  },
}
